import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { IngramAppLinks } from './ingramAppLinks';
import React from 'react';
import { AppQrCode } from './appQrCode';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslate } from '@im/react-localization';

export const LargeScreenLoginTopSection = () => {
  const translateStr = useTranslate();
  return (
    <Stack
      alignItems={'center'}
      direction={'row'}
      display={'flex'}
      flexDirection={'row'}
      height={'376px'}
      justifyContent={'space-between'}
      paddingLeft={'50px'}
      paddingRight={'90px'}
    >
      <Box>
        <img
          alt="Ingram Logo"
          height={'376px'}
          src="/cep/assets/img/login/login-header.webp"
        />
      </Box>
      <Stack display={'flex'} gap={'16px'} justifyContent={'center'}>
        <Stack alignItems={'center'} display={'flex'} rowGap={'16px'}>
          <Typography fontWeight={500} variant="text-md-medium">
            {translateStr('Login.QR_code_header')}
          </Typography>
          <AppQrCode size={133} />
        </Stack>
        <Grid columnGap={'12px'} display={'flex'}>
          <IngramAppLinks height={'40px'} />
        </Grid>
      </Stack>
    </Stack>
  );
};
